import React, { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import * as XLSX from "xlsx";
import "./style.scss";

const RawDatasetsTable = ({ data }: { data: { columns: string[]; content: Array<any> } }) => {
  const dt = useRef<DataTable>(null);
  const maxDatasetPerPage: number = 15;

  const exportCSV = () => {
    dt.current?.exportCSV({ selectionOnly: false });
  };

  const exportExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data.content);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "data.xlsx";
    link.click();
  };

  return (
    <div className="flex flex-column gap-2">
      <div className="text-right">
        <Button
          type="button"
          icon="pi pi-file"
          onClick={exportCSV}
          className="ml-auto p-button-sm mr-2"
          data-pr-tooltip="CSV"
          label="CSV"
        />
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="ml-auto p-button-sm  p-button-success"
          data-pr-tooltip="XLS"
          label="XLS"
        />
      </div>
      <div className="w-full h-full">
        <DataTable
          value={data.content}
          paginator={data.content?.length > maxDatasetPerPage}
          responsiveLayout="scroll"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={maxDatasetPerPage}
          size="small"
          scrollable
          ref={dt}
        >
          <Column header="Date" field="timestamp" />
          {data.columns.map(key => {
            return (
              <Column key={key} field={key} header={key} body={e => (e[key] ? e[key] : "-")} />
            );
          })}
        </DataTable>
      </div>
    </div>
  );
};

export default RawDatasetsTable;
